import { faMagic } from "@fortawesome/duotone-light-svg-icons"
import { Button } from "@joonapp/web-shared"
import { Typography } from "@joonapp/web-shared"
import { useShallow } from "zustand/react/shallow"

import { useCoachOverlayStore } from "./useCoachOverlay"
import { CoachOverlayType } from "../../../types"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../../util/analytics"
import { localStorageItems } from "../../../util/storage"
import useCareTeam from "../../care/useCareTeam"

const NewRoutinesOverlay = () => {
  const { selectedCoachProfile } = useCareTeam()
  const { currentOverlay, setCurrentOverlay, setIsOpenSessionBooking } =
    useCoachOverlayStore(
      useShallow((state) => ({
        currentOverlay: state.currentOverlay,
        setCurrentOverlay: state.setCurrentOverlay,
        setIsOpenSessionBooking: state.setIsOpenSessionBooking,
      }))
    )

  if (currentOverlay !== CoachOverlayType.NEW_ROUTINES) return <></>

  const handleClose = () => {
    trackAnalyticEvent(ANALYTIC_EVENTS.NEW_ROUTINES_OVERLAY_CLOSED)
    localStorage.setItem(
      localStorageItems.lastSeenNewRoutinesOverlay,
      new Date().toISOString()
    )
    setCurrentOverlay(null)
    setIsOpenSessionBooking(false)
  }

  return (
    <div className="flex items-center justify-center absolute top-0 left-0 right-0 bottom-0 z-300 bg-indigo-100/50 backdrop-blur-sm">
      <div className="w-full max-w-[375px] z-2 px-6 py-4 flex flex-col gap-4">
        <div className="w-full flex flex-col items-center gap-2">
          <img
            src="/images/gifs/partying-face.gif"
            alt="new routines"
            className="w-16 h-16 my-4"
          />
          <Typography variant="bodyBold" textAlign="center">
            New week, new routines!
          </Typography>
          <Typography
            variant="body"
            textAlign="center"
            style={{ width: "80%" }}
          >
            Coach{" "}
            {selectedCoachProfile?.nickname ||
              selectedCoachProfile?.user.name ||
              ""}{" "}
            has created a new routine for you!
          </Typography>
        </div>

        <Button
          text="Reveal routine"
          buttonType="primary"
          onClick={handleClose}
          fullWidth
          icon={faMagic}
        />
      </div>
    </div>
  )
}

export default NewRoutinesOverlay
